// extracted by mini-css-extract-plugin
module.exports = {"ring":"Preloader_ring__3y99R","lds-ring":"Preloader_lds-ring__nz+ZR","small":"Preloader_small__cbXtV"};